




















































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import api from "@/network/api";
import { AxiosResponse } from "axios";
import { Getter } from "vuex-class";
import NewsTicker from "@/components/features/NewsTicker.vue";

@Component({
  components: {
    NewsTicker,
  },
})
export default class Leaderboard extends Vue {
  leaders: any = [];
  @Getter("eventId") private eventId!: number;
  prizes: any = [];
  activeTab = "leaderboard";
  description: any = [];
  activities: any = [];

  loadLeaderboardItems() {
    api.get("leaderboard").then((res: AxiosResponse) => {
      this.leaders = res.data.data;
    });
  }

  getPointingSystemDescription() {
    api.get("/leaderboard/pointing-system").then((res: AxiosResponse) => {
      this.description = res.data;
    });
  }

  getUserActivities() {
    api.get("/leaderboard/my-activity").then((res: AxiosResponse) => {
      this.activities = res.data;
    });
  }

  created() {
    this.getUserActivities();
    this.getPointingSystemDescription();
    this.loadLeaderboardItems();
    this.createSubscription();
    this.loadPrizes();
  }

  createSubscription() {
    this.$socket.client.on("NewHighScore." + this.eventId, (payload: any) => {
      this.loadLeaderboardItems();
    });
  }

  beforeDestroy() {
    this.$socket.client.off("NewHighScore." + this.eventId);
  }

  loadPrizes() {
    api.get("event_prizes").then((res: AxiosResponse) => {
      this.prizes = res.data.data;
    });
  }

  rankAsUnicodeCircle(rank: number) {
    const rankCode = 9312 + rank;
    return `&#${rankCode};`;
  }
}
